import { mainApi } from "services/main";

export interface UserOutput {
  alias: string;
  fullName: string;
  businessTitle: string;
  department: string;
}

export interface UserSearchRequest {
  teamName: string;
  keyword: string;
  limit?: number;
}

export interface UserSearchResponse {
  employees: UserOutput[];
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    searchUsers: builder.query<UserSearchResponse, UserSearchRequest>({
      query: (request: UserSearchRequest) => ({
        url: `employees/${request.teamName}`,
        params: {
          keyword: request.keyword,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSearchUsersQuery, useLazySearchUsersQuery } = extendedApi;
